import { AnonymousAvatar, AvatarV2 } from '../AvatarV2'
import { Tooltip } from '../TooltipV2'
import {
  LGStyledAvatarWrapper,
  StyledPlayerHeaderAvatarRoot,
  StyledPlayerHeaderAvatarWrapper,
  XLStyledAvatarWrapper
} from './PlayerHeader.styles'

export interface PlayerAvatarProps {
  avatarSrc: string
  name: string
  isAnonymous: boolean
}

export function PlayerAvatar(props: PlayerAvatarProps): JSX.Element {
  let [AvatarComponent, dataTestId] = props.isAnonymous
    ? [AnonymousAvatar, 'anonymous-avatar']
    : [AvatarV2, 'user-avatar']

  return (
    <StyledPlayerHeaderAvatarRoot>
      <StyledPlayerHeaderAvatarWrapper>
        <LGStyledAvatarWrapper
          data-testid={`${dataTestId}-lg`}
          data-tip
          data-for={`mote-avatar-${props.name}`}
        >
          <AvatarComponent
            size={'lg'}
            name={props.name}
            src={props.avatarSrc}
            alt={`${props.name}`}
          />
        </LGStyledAvatarWrapper>
        <XLStyledAvatarWrapper
          data-testid={`${dataTestId}-xl`}
          data-tip
          data-for={`mote-avatar-${props.name}`}
        >
          <AvatarComponent
            size={'xl'}
            name={props.name}
            src={props.avatarSrc}
            alt={`${props.name}`}
          />
        </XLStyledAvatarWrapper>
        {props.isAnonymous ? (
          <Tooltip id={`mote-avatar-${props.name}`}>
            Sign up to personalise
          </Tooltip>
        ) : null}
      </StyledPlayerHeaderAvatarWrapper>
    </StyledPlayerHeaderAvatarRoot>
  )
}
